import { auth as authText } from "@modules/locales/default.js"

/**
 * todo: merge the file into one with the neighbor 'authentication.tsx' and update constants imports across the app
 * */

export enum LoginOption {
  Github = `GITHUB`,
  Gitlab = `GITLAB`,
  Bitbucket = `BITBUCKET`,
  Google = `GOOGLE`,
  Workos = "WORKOS",
  GithubEnterprise = `GITHUB_ENTERPRISE`,
  GitlabSelfManaged = `GITLAB_SELF_MANAGED`,
}

export const LoginOptionLabels: Record<LoginOption, string> = {
  GITHUB: authText.morphemes.github,
  GITLAB: authText.morphemes.gitlab,
  BITBUCKET: authText.morphemes.bitbucket,
  GOOGLE: authText.morphemes.google,
  WORKOS: authText.morphemes.workos,
  GITHUB_ENTERPRISE: authText.morphemes.githubEnterprise,
  GITLAB_SELF_MANAGED: authText.morphemes.gitlabSelfManaged,
}
